import { render, staticRenderFns } from "./EntregaDocumentos.vue?vue&type=template&id=67851aa2&scoped=true"
import script from "./EntregaDocumentos.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./EntregaDocumentos.vue?vue&type=style&index=0&id=67851aa2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67851aa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67851aa2')) {
      api.createRecord('67851aa2', component.options)
    } else {
      api.reload('67851aa2', component.options)
    }
    module.hot.accept("./EntregaDocumentos.vue?vue&type=template&id=67851aa2&scoped=true", function () {
      api.rerender('67851aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/EntregaDocumentos.vue"
export default component.exports